const HomeZhCN = {
    one: {
        title: "提升您的数位之旅",
        content: `专为您的发展而<strong>设计的技术</strong>。`,
        about_blue: "关于 Blueshine",
    },
    two: {
        title: "重新构想可能性，提升标准",
        content: `尖端技术与<span className="description-highlight font-bold text-secondary">一致的品质</span>结合－加速您的业务发展。`,
    }
}

export default HomeZhCN;